/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { PermissionSwitch, Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export type { PaginationConfigProps } from './TablePagination';
/**
 * 分页配置工具
 */
export {
  createPaginationConfig,
  DEFAULT_PAGE_SIZE_OPTIONS,
} from './TablePagination';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  PermissionSwitch,
  Question,
  SelectLang,
};
